module.exports = __webpack_public_path__ + "img/6.40f9af2a.webp";